import SlimSelect from "slim-select";
import "slim-select/styles";
import "slim-select/scss";
import { postData } from "../api/fetch";
import { getSelectValueById } from "../module/getCatalog";

const slimSelectInstances = new Map();

export function initSelect(selector) {
  const selectEl = document.querySelector(selector);
  if (!selectEl) return;

  const slim = new SlimSelect({
    select: selectEl,
    settings: { showSearch: false },
    events: {
      afterChange: (newVal) => {
        if (selector === "#country") {
          const countryValue = newVal[0]?.value || "all";
          updateMakeList(countryValue);
        } else if (selector === "#make") {
          const makeValue = newVal[0]?.value || "all";
          updateModelList(makeValue);
        }
      },
    },
  });

  slimSelectInstances.set(selectEl, slim);

  if (selector === "#country") {
    updateMakeList(getSelectValueById("country"));
  }
}

// ✅ правильный reset
export function resetSlimSelects(container = document) {
  const selects = container.querySelectorAll(".custom-select__field");

  selects.forEach((select) => {
    const slim = slimSelectInstances.get(select);
    if (!slim) return;

    // берем первое значение option (у тебя это "Любой")
    const firstValue = select.options[0]?.value;

    slim.setSelected(firstValue);
  });
}

// Вспомогательная функция для извлечения параметров из URL
function getParamsFromURL() {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const catalogIndex = pathSegments.indexOf("catalog");

  if (catalogIndex === -1) {
    return { country: "all", make: "all", model: "all" };
  }

  const country = pathSegments[catalogIndex + 1] || "all";
  const make = pathSegments[catalogIndex + 2] || "all";
  const model = pathSegments[catalogIndex + 3] || "all";

  return { country, make, model };
}

export function updateMakeList(country) {
  const makeSelect = document.querySelector("#make");
  if (!makeSelect) return;

  const countryValue = country || getSelectValueById("country") || "all";

  // Отправляем запрос на новое API
  fetch("/api/brands", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN":
        document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content") || "",
    },
    body: JSON.stringify({ country: countryValue }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      // ✅ Извлекаем марку из URL
      const urlParams = getParamsFromURL();
      let selectedMake = urlParams.make || "all";

      // Проверяем, есть ли такая марка в данных
      const makeExists = data.some(
        (brand) =>
          brand.slug === selectedMake ||
          brand.name.toLowerCase().replace(/\s+/g, "_") === selectedMake,
      );

      if (!makeExists) {
        selectedMake = "all";
      }

      // Формируем массив данных для SlimSelect
      const slimData = [
        { text: "Любая", value: "all" },
        ...(Array.isArray(data) && data.length
          ? data.map((brand) => ({
              text: brand.name,
              value:
                brand.slug || brand.name.toLowerCase().replace(/\s+/g, "_"),
            }))
          : []),
      ];

      // Обновляем или создаем SlimSelect
      if (slimSelectInstances.has(makeSelect)) {
        const slim = slimSelectInstances.get(makeSelect);
        slim.setData(slimData);
        slim.setSelected(selectedMake);
      } else {
        const slim = new SlimSelect({
          select: makeSelect,
          data: slimData,
          settings: {
            showSearch: false,
            placeholderText: "Выберите марку",
          },
          events: {
            afterChange: (newVal) => {
              const makeValue = newVal[0]?.value || "all";
              if (typeof updateModelList === "function") {
                updateModelList(makeValue);
              }
            },
          },
        });
        slimSelectInstances.set(makeSelect, slim);
        slim.setSelected(selectedMake);
      }
    })
    .catch((err) => {
      console.error("Ошибка при получении марок:", err);
      const errorData = [{ text: "Любая", value: "all" }];

      if (slimSelectInstances.has(makeSelect)) {
        const slim = slimSelectInstances.get(makeSelect);
        slim.setData(errorData);
        slim.setSelected("all");
      } else {
        const slim = new SlimSelect({
          select: makeSelect,
          data: errorData,
          settings: { showSearch: false },
        });
        slimSelectInstances.set(makeSelect, slim);
      }
      console.error("Ошибка при получении марок:", err);
    });
}

export function updateModelList(make) {
  const modelSelect = document.querySelector("#model");
  if (!modelSelect) return;

  const makeValue = make || getSelectValueById("make") || "all";
  const countryValue = getSelectValueById("country") || "all";

  // ✅ Функция для обновления данных в селекте
  const updateSelectData = (data, selectedValue = "all") => {
    if (slimSelectInstances.has(modelSelect)) {
      const slim = slimSelectInstances.get(modelSelect);
      slim.setData(data);
      slim.setSelected(selectedValue);
    } else {
      const slim = new SlimSelect({
        select: modelSelect,
        data: data,
        settings: { showSearch: false },
      });
      slimSelectInstances.set(modelSelect, slim);
      slim.setSelected(selectedValue);
    }
  };

  // ✅ Очищаем список и выбираем "Любая" перед запросом
  // const loadingData = [{ text: "Загрузка...", value: "all" }];
  const loadingData = [{ text: "Загрузка моделей...", value: "all" }];
  updateSelectData(loadingData, "all");

  // ✅ Если марка не выбрана — очищаем список и выходим
  if (!makeValue || makeValue === "all") {
    const slimData = [{ text: "Любая", value: "all" }];
    setTimeout(() => updateSelectData(slimData, "all"), 50);
    return;
  }

  // Запрос на получение моделей
  fetch("/api/models", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN":
        document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content") || "",
    },
    body: JSON.stringify({
      make: makeValue,
      country: countryValue,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      // ✅ Извлекаем модель из URL
      const pathSegments = window.location.pathname.split("/").filter(Boolean);
      const catalogIndex = pathSegments.indexOf("catalog");
      let selectedModel = "all";

      if (catalogIndex !== -1) {
        const modelIndex = catalogIndex + 3;
        if (pathSegments.length > modelIndex) {
          const modelFromUrl = pathSegments[modelIndex];
          if (
            Array.isArray(data) &&
            data.some(
              (m) =>
                m.slug === modelFromUrl ||
                m.name.toLowerCase().replace(/\s+/g, "_") === modelFromUrl,
            )
          ) {
            selectedModel = modelFromUrl;
          }
        }
      }

      const slimData = [
        { text: "Любая", value: "all" },
        ...(Array.isArray(data) && data.length
          ? data.map((model) => ({
              text: model.name,
              value:
                model.slug || model.name.toLowerCase().replace(/\s+/g, "_"),
            }))
          : []),
      ];

      // ✅ Обновляем с выбранной моделью
      setTimeout(() => updateSelectData(slimData, selectedModel), 50);
    })
    .catch((err) => {
      console.error("Ошибка при получении моделей:", err);
      const errorData = [{ text: "Любая", value: "all" }];
      setTimeout(() => updateSelectData(errorData, "all"), 50);
    });
}
